import { useMemo } from 'react';

/**
 * StatusBadge — renders a colored pill for resident status.
 * @param {{ status: string }} props
 *   status — "Active" | "Moved Out" | "Pending Move-In"
 */
const StatusBadge = ({ status }) => {
  const modifier = useMemo(() => {
    switch (status) {
      case 'Active':          return 'rp-status--active';
      case 'Moved Out':       return 'rp-status--moved-out';
      case 'Pending Move-In': return 'rp-status--pending';
      default:                return 'rp-status--moved-out';
    }
  }, [status]);

  return (
    <span className={`rp-status ${modifier}`}>
      <span className="rp-status__dot" aria-hidden="true" />
      {status}
    </span>
  );
};

export default StatusBadge;
